function formatNumberToYears(number) {
  return number === 1 ? '1 year' : `${number} years`
}

export default formatNumberToYears;
